import React, {useContext} from 'react';
import {Grid} from '@material-ui/core';
import SelectField from '../../../../FormikUtils/SelectField'
import {Field} from 'formik'
import FormikAutocomplete from "../../../../FormikUtils/FormikAutocomplete";
import CotizarContext from "../../../../../../context/CotizarContext";
import InputField from "../../../../FormikUtils/InputField";

export default function InformacionForm(props) {
    const {
        formField: {
            tamanioVivienda,
            tipoVivienda,
            codigosLocalidad,
            afinidad,
            deducible,
            fechaCotizacion
        }
    } = props;

    const {localidades, afinidades} = useContext(CotizarContext)

    const deducibles = [
        {value: "0", label: 'Sin deducible'},
        {value: "1", label: 'Deducible Alt. 1'},
        {value: "2", label: 'Deducible Alt. 2'},
        {value: "3", label: 'Deducible Alt. 3'}
    ];
    const tiposViviendas = [
        {value: '1021', label: 'Casa'},
        {value: '1022', label: 'Departamento'},
        {value: '1023', label: 'Vivienda en barrio cerrado'},
        {value: '1024', label: 'Vivienda transitoria'}
    ];
    const tamaniosVivienda = [
        {value: 'Chica', label:'Pequeña (Hasta 80 mts²)'},
        {value: 'Mediana', label: 'Mediana (Hasta 150 mts²)'},
        {value: 'Grande', label: 'Grande (150 mts² o más)'},
    ];

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <Field
                        name={afinidad.name}
                        label={afinidad.label}
                        component={FormikAutocomplete}
                        options={afinidades}
                        textFieldProps={{
                            label: afinidad.label,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={fechaCotizacion.name}
                        label={fechaCotizacion.label}
                        type="date"
                        fullWidth
                        InputLabelProps={{shrink: true,}}
                        textTransform={'lowercase'}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={tipoVivienda.name}
                        label={tipoVivienda.label}
                        data={tiposViviendas}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        component={FormikAutocomplete}
                        options={localidades}
                        textFieldProps={{
                            label: codigosLocalidad.label,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={tamanioVivienda.name}
                        label={tamanioVivienda.label}
                        data={tamaniosVivienda}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={deducible.name}
                        label={deducible.label}
                        data={deducibles}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
